"use strict";

(function () {
  jQuery.ajax({
    url: "https://adparlor.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/v7ee31/b/5/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=ca248a10",
    type: "get",
    cache: true,
    dataType: "script"
  });

  var user = localStorage.getItem("User");

  var getUserName = function getUserName() {
    if (user) {
      var parsedUser = JSON.parse(user);
      return parsedUser.first_name + " " + parsedUser.last_name;
    }
    return "Unknown";
  };

  var getUserEmail = function getUserEmail() {
    if (user) {
      return JSON.parse(user).email;
    }
    return "Unknown";
  };

  window.ATL_JQ_PAGE_PROPS = {
    triggerFunction: function triggerFunction(showCollectorDialog) {
      jQuery("body").on('click', '#showJiraIssueCollector', function (e) {
        e.preventDefault();
        showCollectorDialog();
      });
    },
    environment: {
      user_name: getUserName(),
      user_email: getUserEmail()
    }
  };
})();